<template>
  <section class="vps-indonesia">
    <Hero />
    <Pricing />
    <Benefit />
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Hero from "@/components/views/services/vpsid/hero.vue";
import Pricing from "@/components/views/services/vpsid/pricing.vue";
import Benefit from "@/components/views/services/vpsid/benefit.vue";

export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "VPS Indonesia | Zoinix Inter Technology",
      url: "https://zoinix.com/services/vps-indonesia",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Hero, Pricing, Benefit },
});
</script>
